import Storage from '@/utils/Storage'
import { embedOptions as platformsOfEmbed } from '@/utils/embedOptions.js'
import embedOptionOrientations from '@/utils/embedOptionOrientations.js'

export default {
  data: () => ({
    isChangingPlatform: false,
    hlsEmbed: false,
    codeEmbed: false,
    srcEmbed: false,
    isExternalIdEmbed: false,
    radioActive: 0,
    videoCustomSize: false,
    embedOptionOrientations,
    embedSelected: '',
    embedTrademark: '',
    embedClassHelp: '',
    embedLinkHelp: '',
    embedVideo: {},
  }),

  computed: {
    aspectRatio() {
      const { width, height } = this.video
      let ratio = height / width

      if (Number.isNaN(ratio)) {
        ratio = 9 / 16
      }

      return `${ratio * 100}%`
    },
    isLandscapeOrientation() {
      return parseFloat(this.aspectRatio) < 100
    },
    embedOptions() {
      const [general] = platformsOfEmbed.filter(
        ({ value }) => value === 'general'
      )
      const rest = platformsOfEmbed.filter(({ value }) => value !== 'general')
      const sorted = rest.sort((a, b) => a.value.localeCompare(b.value))

      return [general, ...sorted]
    },
  },

  watch: {
    radioActive() {
      if (this.isChangingPlatform) return

      this.embedSelected = 'general'
      this.handleEmbedSelection()
    },
  },

  methods: {
    handleEmbedSelection() {
      this.embedSelected = this.embedSelected || 'general'
      const [selectedOption] = this.embedOptions.filter(
        (item) => item.value === this.embedSelected
      )

      const isExternalIdEmbed = ['123tapronto', 'tucano-members']
      const isSrcEmbed = [
        'cademi',
        'classbuild',
        'engaged',
        'monetizze',
        'blitzpay',
        'ensinio',
        'membertizze',
        'ticto',
      ]
      const isCodeEmbed = ['entrega-digital', 'creators-land']
      const isHLSEmbed = ['xgrow', 'greatpages', 'minervaead']
      const isRadioActiveFalse = Object.keys(this.embedOptionOrientations)
      const isRadioActiveTrue = this.embedOptions
        .map(({ value }) => {
          if (
            ![...isHLSEmbed, ...isRadioActiveFalse, 'general'].includes(value)
          )
            return value
        })
        .filter(Boolean)

      this.isExternalIdEmbed = false
      this.hlsEmbed = false
      this.codeEmbed = false
      this.srcEmbed = false
      this.isChangingPlatform = true
      const option = selectedOption ?? this.embedOptions[0]
      this.embedTrademark = option.text
      this.embedLinkHelp = option.help
      this.embedClassHelp = ''

      if (!this.embedLinkHelp) {
        this.embedClassHelp = 'd-none'
      }

      if (isExternalIdEmbed.includes(this.embedSelected)) {
        this.isExternalIdEmbed = true
        this.radioActive = 0
      } else if (isSrcEmbed.includes(this.embedSelected)) {
        this.srcEmbed = true
        this.radioActive = 0
      } else if (isCodeEmbed.includes(this.embedSelected)) {
        this.codeEmbed = true
        this.radioActive = 0
      } else if (isHLSEmbed.includes(this.embedSelected)) {
        this.hlsEmbed = true
        this.radioActive = 1
      } else {
        if (isRadioActiveTrue.includes(this.embedSelected)) {
          this.videoCustomSize = true
          this.radioActive = 1
        } else if (isRadioActiveFalse.includes(this.embedSelected)) {
          const orientation = this.isLandscapeOrientation
            ? 'landscape'
            : 'portrait'
          const { width, height } =
            this.embedOptionOrientations[this.embedSelected][orientation]

          this.videoCustomSize = false
          this.radioActive = 0

          this.embedVideo.width = width
          this.embedVideo.height = height
        }

        Storage.setItem('width', this.embedVideo.width)
        Storage.setItem('height', this.embedVideo.height)
      }

      Storage.setItem('embedType', this.embedSelected)

      setTimeout(
        function () {
          this.isChangingPlatform = false
        }.bind(this),
        1
      )
    },
  },
}
